import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: [],
	page: 1,
	perPage: 10,
	totalItems: 0,
	totalPage: 0,
	loading: false,
};

const creditLimitSlice = createSlice({
	name: "creditLimit",
	initialState,
	reducers: {
		setCreditLimitsData: (state, action) => {
			const { data, totalItems, page, perPage } = action.payload;

			state.data = data || [];
			state.totalItems = totalItems || 0;
			state.page = page || 1;
			state.perPage = perPage || 10;
			state.totalPage = Math.ceil(totalItems / perPage);
		},
		setLoadingCreditLimits: (state, action) => {
			state.loading = action.payload;
		},
	},
});

export const { setCreditLimitsData, setLoadingCreditLimits } = creditLimitSlice.actions;
export default creditLimitSlice.reducer;
